import { Typography, useTheme } from "@mui/material";
import { AlertTriangle } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CenteredIconState } from "web_myplann/Shared/Components/CenteredIconState";

export const FinancesErrorState: FC = () => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<CenteredIconState
			icon={AlertTriangle}
			iconBg={theme.palette.red[100]}
			iconColor={theme.palette.red[600]}
		>
			<Typography variant="body2">
				{t(Resources.Common.somethingWentWrong)}
			</Typography>
		</CenteredIconState>
	);
};
